import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { useCaptchaConfig } from "../../../hooks/useCaptchaConfig";

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`;

const Input = styled.input`
  width: 72px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
`;

const Error = styled.span`
  color: #dc2626;
  font-size: 0.85rem;
`;

const Hint = styled.span`
  color: #64748b;
  font-size: 0.85rem;
`;

/** Math CAPTCHA — visibility enforced when backend CAPTCHA_ENABLED=true. */
export function CaptchaField({ onValidatedChange, onChallengeChange, onStatusChange }) {
  const { enabled, required, loaded } = useCaptchaConfig();
  const a = useMemo(() => Math.floor(Math.random() * 8) + 1, []);
  const b = useMemo(() => Math.floor(Math.random() * 8) + 1, []);
  const [answer, setAnswer] = useState("");
  const valid = Number(answer) === a + b;

  React.useEffect(() => {
    if (!loaded) {
      onStatusChange?.({ loading: true, required: false });
      onValidatedChange?.(false);
      return;
    }
    if (!required) {
      onStatusChange?.({ loading: false, required: false });
      onValidatedChange?.(true);
      onChallengeChange?.({});
      return;
    }
    onStatusChange?.({ loading: false, required: true });
    onValidatedChange?.(valid);
  }, [loaded, required, valid, onValidatedChange, onChallengeChange, onStatusChange]);

  React.useEffect(() => {
    if (!loaded || !required) return;
    onChallengeChange?.({
      captcha_a: String(a),
      captcha_b: String(b),
      captcha_answer: answer,
    });
  }, [loaded, required, a, b, answer, onChallengeChange]);

  if (!loaded) {
    return <Hint>Loading security check…</Hint>;
  }

  if (!enabled) return null;

  return (
    <Wrap>
      <span>What is {a} + {b}?</span>
      <Input
        type="number"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        aria-label="CAPTCHA answer"
      />
      {!valid && answer !== "" && <Error>Incorrect answer</Error>}
    </Wrap>
  );
}

export default CaptchaField;
